import { UserInfo } from '../constants/types';

type AuthStoreListener = (user: UserInfo | null) => void;

class AuthStore {
  user: UserInfo | null = null;
  listeners: AuthStoreListener[] = [];

  setUser(user: UserInfo | null) {
    this.user = user;
    this.listeners.forEach(cb => cb(user));
  }

  subscribe(cb: AuthStoreListener) {
    this.listeners.push(cb);
    return () => {
      this.listeners = this.listeners.filter(l => l !== cb);
    };
  }
}

export default new AuthStore();
